import React, { useEffect, useState } from 'react';
import styles from './resetPwdComplete.module.scss';
import PersonalComplete from '../../static/images/personal_complete.png';
import  { ApiCore } from '../../api/index';
import { Button } from 'antd-mobile-v5';

const api = new ApiCore();
function ResetPwdComplete(props: any) {

    useEffect(() => {
        document.title = '重置密码';
        initData();
        return () => {
        }
    }, [])


    const initData = () => {
    }

    const toHome= () => {
        let fromUrl = sessionStorage.getItem('ResetPasswordFromPath');
        if (fromUrl) {
            props.history.push(fromUrl);
        } else {
            props.history.push('/login');
        }
    }

    return (
        <div className={`${styles.resetPwdComplete_content}`}>
            <img className={`${styles.complete_tip}`} src={PersonalComplete} alt="" />
            <div className={`${styles.complete_word1}`}>重置完成</div>
            <div className={`${styles.complete_word2}`}>您的密码已重置完成，</div>
            <div className={`${styles.complete_word3}`}>请使用新的密码进行登录</div>
            <Button className={`${styles.complete_btn}`} color='primary' onClick={() => { toHome() }}>完成</Button>
        </div>
    )

}

export default ResetPwdComplete;